// Central source for contact links, case studies and editorial content.
// Case-study links are verified against Pranjali's public Behance profile.
export const contact = {
  email: 'saxenaprini@gmail.com', phone: '+91 8923370361',
  location: 'Bengaluru, Karnataka, India',
  behance: 'https://www.behance.net/prinisaxena',
  linkedin: 'https://www.linkedin.com/in/pranjali-saxena/',
  instagram: 'https://www.instagram.com/prinisaxena/',
  resume: `${process.env.REACT_APP_BACKEND_URL}/api/resume`,
};

export const projects = [
  { id: 'solara', number: '01', title: 'SOLARA', category: 'Brand Identity · Social Media Design',
    description: 'Building a warm visual language around an everyday ritual.', year: '2026',
    tools: ['Figma', 'Illustrator', 'Photoshop'], type: 'Branding',
    image: '/images/refinements/solara.webp', behanceUrl: 'https://www.behance.net/gallery/225121565/Solara-Brand-Identity' },
  { id: 'rarefore', number: '02', title: 'RAREFORE', category: 'Social Media · Cultural Design',
    description: 'Visual storytelling for culture-led events, campaigns and communities.', year: '2025',
    tools: ['Figma', 'Photoshop', 'Illustrator', 'DaVinci Resolve'], type: 'Campaigns',
    image: '/images/photo-update/rarefore.webp', alternateImage: '/images/rarefore-chapters.webp', behanceUrl: 'https://www.behance.net/gallery/237875087/Rarefore' },
  { id: 'photobook', number: '03', title: 'PHOTOBOOK - FEELING LIKE HOME', category: 'Photography · Book Design',
    description: 'A photography book exploring the places and everyday details that feel like home.', year: '2025',
    tools: [], type: 'Photography',
    image: '/images/photo-update/photobook.webp', behanceUrl: 'https://www.behance.net/gallery/217112341/Feeling-like-Home-(Photobook)' },
  { id: 'kora-estate', number: '04', title: 'KORA ESTATE', category: 'Identity · Signage · Brand Design',
    description: 'Bringing a sense of place, craft and Coorg into a contemporary identity.', year: '2026',
    tools: ['Illustrator', 'Figma'], type: 'Branding',
    image: '/images/refinements/project-a.webp', behanceUrl: 'https://www.behance.net/gallery/255456557/Kora-Estate-Brand-Identity' },
  { id: 'life-in-rarez', number: '05', title: 'LIFE IN RAREZ', category: 'Campaign · Visual Design',
    description: 'Turning product stories into bold, platform-first visual communication.', year: '2026',
    tools: [], type: 'Campaigns',
    image: '/images/refinements/project-b.webp', behanceUrl: 'https://www.behance.net/gallery/254504967/LIFE-IN-RAREZ-An-AI-first-visual-campaign' },
  { id: 'enchantoys', number: '06', title: 'ENCHANTOYS', category: 'Packaging · Visual Storytelling',
    description: 'Packaging that makes the story part of the experience.', year: '2026',
    tools: ['Illustrator', 'Figma', 'Photoshop'], type: 'Packaging',
    image: '/images/photo-update/enchantoys.webp', behanceUrl: 'https://www.behance.net/gallery/255998313/Enchantoys-Packaging-Design' },
  { id: 'nimmalakunta', number: '07', title: 'NIMMALAKUNTA', category: 'Brand Identity · Cultural Branding',
    description: 'Bringing a centuries-old craft into a contemporary visual language.', year: '2025',
    tools: [], type: 'Branding',
    image: '/images/photo-update/nimmalakunta.webp', behanceUrl: 'https://www.behance.net/gallery/224559267/Nimmalakunta-Place-Branding' },
];

export const experience = [
  { company: 'THE HOUSE OF RARE', role: 'Graphic Design · Campaigns · Social', dates: 'Dec 2025 – Apr 2026',
    description: 'Worked across Rarez and Rarefore on social content, campaign creatives and culture-led visual storytelling. Translated briefs into platform-first visuals while working closely with content and marketing teams.' },
  { company: 'THE HOUSE OF RARE / RAREFORE', role: 'Graphic Design Intern', dates: 'Jun 2025 – Aug 2025',
    description: 'Designed digital and print communication for cultural chapters including Verge and Megh, building cohesive visual systems around their event narratives.' },
  { company: 'SIMFINITY STUDIO', role: 'Graphic Design', dates: 'Sep 2024 – May 2025',
    description: 'Developed brand identities, campaigns and marketing collateral for startups and small businesses across web, social and print.' },
  { company: 'DEZINN', role: 'Graphic Design Intern', dates: 'Aug 2023 – Mar 2024',
    description: 'Assisted across branding, product visualisation, packaging, illustration and presentation design.' },
];

export const tools = [
  { id: 'figma', title: 'FIGMA' },
  { id: 'photoshop', title: 'PHOTOSHOP' },
  { id: 'illustrator', title: 'ILLUSTRATOR' },
  { id: 'resolve', title: 'DAVINCI RESOLVE' },
];